import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';

export default function Filter({ label, query, range, name, unitLabel, ...props }) {
  let input;
  if (range) {
    input = (
      <div className="d-flex justify-content-between align-items-center gap-1">
        <ManagedInput
          className="form-control"
          icon={unitLabel}
          name={`${name}Gteq`}
          value={query[`${name}Gteq`]}
          {...props}
        />

        <span className="text-center">to</span>

        <ManagedInput
          className="form-control"
          icon={unitLabel}
          name={`${name}Lteq`}
          value={query[`${name}Lteq`]}
          {...props}
        />
      </div>
    );
  } else {
    input = (
      <ManagedInput
        className="form-control"
        name={name}
        value={query[name]}
        {...props}
      />
    );
  }

  return (
    <div className="form-group">
      <label>{label}</label>
      {input}
    </div>
  );
}

Filter.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  range: PropTypes.bool,
  unitLabel: PropTypes.node,
};
